import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=5993259b&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=ts"
export * from "./Pay.vue?vue&type=script&lang=ts"
import style0 from "./Pay.vue?vue&type=style&index=0&id=5993259b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5993259b",
  null
  
)

export default component.exports